import { createContext, use } from "react";
import type { OrganizationPerson } from "../../state/governance";
import { Avatar, AvatarFallback, AvatarImage, personInitials } from "../ui/avatar";
import { HoverCard, HoverCardPopup, HoverCardTrigger } from "../ui/hover-card";
import { PersonCard } from "./PersonAvatars";

export const MentionPeopleContext = createContext<readonly OrganizationPerson[]>([]);
const colors = [
  "bg-violet-500/12 text-violet-700 dark:text-violet-300",
  "bg-sky-500/12 text-sky-700 dark:text-sky-300",
  "bg-emerald-500/12 text-emerald-700 dark:text-emerald-300",
  "bg-rose-500/12 text-rose-700 dark:text-rose-300",
];
export function MentionAvatar({
  person,
}: {
  person: Pick<OrganizationPerson, "name" | "email" | "avatarUrl">;
}) {
  return (
    <Avatar className="size-5 shrink-0 text-[9px]">
      {person.avatarUrl ? (
        <AvatarImage
          src={person.avatarUrl}
          alt=""
          className="absolute inset-0"
          onError={(event) => {
            event.currentTarget.style.display = "none";
          }}
        />
      ) : null}
      <AvatarFallback className="bg-current/10 text-inherit">
        {personInitials(person)}
      </AvatarFallback>
    </Avatar>
  );
}
export function UserMention({ userId, label }: { userId: string; label: string }) {
  const person = use(MentionPeopleContext).find((item) => item.userId === userId);
  const color =
    colors[Array.from(userId).reduce((sum, char) => sum + char.charCodeAt(0), 0) % colors.length];
  const chip = (
    <span
      data-composer-user-chip="true"
      contentEditable={false}
      className={`inline-flex max-w-full items-center gap-1 rounded-md px-1.5 py-0.5 align-middle text-xs font-medium ${color}`}
    >
      <MentionAvatar person={person ?? { name: label, email: "", avatarUrl: null }} />
      <span className="truncate">@{person?.name || person?.email || label}</span>
    </span>
  );
  return person ? (
    <HoverCard>
      <HoverCardTrigger render={<span tabIndex={0} />}>{chip}</HoverCardTrigger>
      <HoverCardPopup className="w-72">
        <PersonCard person={person} />
      </HoverCardPopup>
    </HoverCard>
  ) : (
    chip
  );
}
